import $ from 'jquery';

export default () => {
    let getSectorUrl = null;
    let getSectorOffset = null;
    let parts = null;
    let rex = /\/sectors\/([^;\?]+)/;

    const $topTen = $('.top-10');
    const $micTenBlock = $('.mic-10-block');
    const $arrow = $('.arrow');

    $topTen.click(function (e) {
        if ($(e.target).is('a') || $(e.target).parent().is('a')) {
            return;
        }
        $(this).find($micTenBlock).slideToggle(300);
        $(this).find($arrow).toggleClass('arrow arrow-down');
    });

    // Extract china from http://fastcompany.local:8880/most-innovative-companies/sectors/china
    parts = rex.exec(window.location.href);
    // Test parts were extracted
    if (parts && parts[1]) {
        // Give ads a chance to load
        setTimeout(function () {
            // Create ID selector
            getSectorUrl = '#' + parts[1];
            // Find where ID'd div lives on the page
            getSectorOffset = $(getSectorUrl).offset().top - 100;
            // Animate scroll over .3 seconds
            $('body').animate({
                scrollTop: getSectorOffset
            }, 300);
            // Trigger accordion animation
            $(getSectorUrl).trigger('click');
        }, 1000);
    }
};
